module.exports = __webpack_public_path__ + "zhichi1-e2fea897.png";